import React from 'react';
import { ThemeProvider } from 'styled-components';
import { BrowserRouter as Router, Switch, Route as RouterRoute } from 'react-router-dom';
import { Provider } from 'unstated';
import CssBaseline from '@material-ui/core/CssBaseline';
import { MuiThemeProvider } from '@material-ui/core/styles';
import MuiPickersUtilsProvider from 'material-ui-pickers/utils/MuiPickersUtilsProvider';
import MomentUtils from 'material-ui-pickers/utils/moment-utils';

import { theme, muiTheme } from './styles/theme';
import Route from './components/Route';
import Home from './pages/Home';
import Login from './pages/Login';
import NotFound from './pages/NotFound';
import ManageUser from './pages/ManageUser';
import RegistrationForm from './pages/RegistrationForm';
import RegistrationQuiz from './pages/RegistationQuiz';
import SelectionStages from './pages/SelectionStages';
import KnowledgeTestQuiz from './pages/KnowledgeTestQuiz';
import Dashboard from './pages/Dashboard';
import GroupDiscussionDetail from './pages/GroupDiscussionDetail';
import AttendanceSheet from './pages/AttendanceSheet';
import AttendanceReport from './pages/AttendanceReport';
import MPTrack from './pages/MPTrack';
import DBIndex from './pages/DBIndex';
import BillTrack from './pages/BillTrack';
import BillDetail from './pages/BillDetail';
import IssueTrack from './pages/IssueTrack';
import BudgetTrack from './pages/BudgetTrack';
import Productivity from './pages/Productivity';
import Confirmation from './pages/Confirmation';
import Venue from './pages/Venue';

const App = () => (
  <MuiPickersUtilsProvider utils={MomentUtils}>
    <Provider>
      <React.Fragment>
        <CssBaseline />

        <Router>
          <ThemeProvider theme={theme}>
            <MuiThemeProvider theme={muiTheme}>
              <Switch>
                <Route
                  path="/"
                  exact
                  component={Home}
                  userTypesAllowed={['ADMIN', 'CITY_IMPACT_MANAGER']}
                  protectedRoute
                />
                <Route path="/login" component={Login} />
                <RouterRoute path="/registration" component={RegistrationForm} />
                <RouterRoute path="/confirmation" component={Confirmation} />
                <RouterRoute
                  path="/registration-quiz/:registrationId"
                  component={RegistrationQuiz}
                />
                <RouterRoute path="/knowledge-test" component={KnowledgeTestQuiz} />
                <Route
                  path="/manage-user"
                  component={ManageUser}
                  userTypesAllowed={['ADMIN']}
                  protectedRoute
                />
                <Route
                  path="/selection-stage/:stageId"
                  component={SelectionStages}
                  userTypesAllowed={['ADMIN', 'CITY_IMPACT_MANAGER']}
                  protectedRoute
                />
                <Route
                  path="/dashboard"
                  component={Dashboard}
                  userTypesAllowed={['ADMIN']}
                  protectedRoute
                />
                <Route
                  path="/group-discussion/:groupId"
                  component={GroupDiscussionDetail}
                  userTypesAllowed={['ADMIN']}
                  protectedRoute
                />
                <Route
                  path="/attendance-sheet"
                  component={AttendanceSheet}
                  userTypesAllowed={['ADMIN', 'CITY_IMPACT_MANAGER']}
                  protectedRoute
                />
                <Route
                  path="/attendance-report"
                  component={AttendanceReport}
                  userTypesAllowed={['ADMIN', 'CITY_IMPACT_MANAGER']}
                  protectedRoute
                />
                <Route
                  path="/mp-track"
                  component={MPTrack}
                  userTypesAllowed={['ADMIN', 'CITY_IMPACT_MANAGER']}
                  protectedRoute
                />
                <Route
                  path="/db-index"
                  component={DBIndex}
                  userTypesAllowed={['ADMIN']}
                  protectedRoute
                />
                <Route
                  exact
                  path="/bill-track"
                  component={BillTrack}
                  userTypesAllowed={['ADMIN', 'CITY_IMPACT_MANAGER']}
                  protectedRoute
                />
                <Route
                  path="/bill-track/:billID"
                  component={BillDetail}
                  userTypesAllowed={['ADMIN', 'CITY_IMPACT_MANAGER']}
                  protectedRoute
                />
                <Route
                  path="/issue-track"
                  component={IssueTrack}
                  userTypesAllowed={['ADMIN', 'CITY_IMPACT_MANAGER']}
                  protectedRoute
                />
                <Route
                  path="/budget-track"
                  component={BudgetTrack}
                  userTypesAllowed={['ADMIN', 'CITY_IMPACT_MANAGER']}
                  protectedRoute
                />
                <Route
                  path="/productivity"
                  component={Productivity}
                  userTypesAllowed={['ADMIN']}
                  protectedRoute
                />
                <Route
                  path="/venue"
                  component={Venue}
                  userTypesAllowed={['ADMIN']}
                  protectedRoute
                />
                <Route component={NotFound} />
              </Switch>
            </MuiThemeProvider>
          </ThemeProvider>
        </Router>
      </React.Fragment>
    </Provider>
  </MuiPickersUtilsProvider>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js